import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import SiteLayout from "../components/feature/SiteLayout";
import Home from "../pages/home/page";
import WorksList from "../pages/works/page";
import WorkDetail from "../pages/workDetail/page";
import NewsList from "../pages/news/page";
import NewsDetail from "../pages/newsDetail/page";
import CharactersList from "../pages/characters/page";
import CharacterDetail from "../pages/characterDetail/page";
import About from "../pages/about/page";
import Search from "../pages/search/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <SiteLayout />,
    children: [
      { index: true, element: <Home /> },
      { path: "works", element: <WorksList /> },
      { path: "works/:id", element: <WorkDetail /> },
      { path: "news", element: <NewsList /> },
      { path: "news/:id", element: <NewsDetail /> },
      { path: "characters", element: <CharactersList /> },
      { path: "characters/:id", element: <CharacterDetail /> },
      { path: "about", element: <About /> },
      { path: "search", element: <Search /> },
      { path: "*", element: <NotFound /> },
    ],
  },
];

export default routes;